module.exports = __webpack_public_path__ + "static/media/geesaa_4.3e83a987.PNG";